import React from 'react';
import { Seo, blog } from '~/marketing/Seo';
import { routes } from '~/marketing/routes';
import { withMarketingLayout } from '~/marketing/MarketingLayout';
import { PostCard } from '~/marketing/PostCard';
import { POSTS } from '~/marketing/blog';

/* The blog's index: every post in `blog/posts.json`, newest first. Nothing on
   it is written per post. */
export default function Blog() {
  return (
    <>
      <Seo
        title="Blog"
        description="How AI assistants decide which local business to name, what you can do about it, and what we find when we measure it."
        path={routes.blog}
        schema={[ blog(POSTS) ]}
      />
      <main className="sp-page" style={{ paddingBlock: 'clamp(40px,5vw,80px)', display: 'grid', gap: 'var(--space-10)' }}>
        <header style={{ display: 'grid', gap: 'var(--space-4)', maxWidth: '62ch' }}>
          <span className="sp-label">Blog</span>
          <h1 style={{ fontSize: 'var(--fs-display-2)', lineHeight: 1.06 }}>Answer engine optimization, explained and measured</h1>
          <p style={{ color: 'var(--text-body)', fontSize: 'var(--fs-body-lg)', margin: 0 }}>
            How AI assistants decide which local business to name, what you can do about it, and what we find when we measure it. Each post says when its figures were collected and which AI assistants they came from.
          </p>
        </header>
        <div style={{ display: 'grid', gap: 'var(--space-4)', maxWidth: '72ch' }}>
          {POSTS.map((post) => <PostCard key={post.path} post={post} />)}
        </div>
      </main>
    </>
  );
}

Blog.layout = withMarketingLayout;
